/* eslint-disable no-console */

import React from 'react';
import axios from 'axios';
import firebase from 'firebase';
import { useAuthState } from 'react-firebase-hooks/auth';
import PropTypes from 'prop-types';
import ShoppingCartQuickViewContext from '../ShoppingCart/ShoppingCartQuickView/shopping-cart-quick-view-context';
import ShoppingCartQuickView from '../ShoppingCart/ShoppingCartQuickView';
import 'react-sliding-pane/dist/react-sliding-pane.css';

let SlidingPane = null;
if (typeof window !== 'undefined') {
// eslint-disable-next-line global-require
    SlidingPane = require('react-sliding-pane').default;
}

const Layout = ({ id, className, children }) => {
    const [cartQuickViewOpen, setCartQuickViewOpen] = React.useState(false);
    // eslint-disable-next-line no-unused-vars
    const [authUser, initialising, userDataError] = typeof window !== 'undefined' ? useAuthState(firebase.auth()) : Array(3);
    if (authUser && !initialising) {
        authUser
            .getIdToken()
            .then((authToken) => {
                axios.defaults.headers.common.Authorization = `Bearer ${authToken}`;
            })
            .catch(tokenError => console.log('tokenError', tokenError));
    }

    if (!initialising && authUser) {
        // console.log('INTERCEPTOR');
        axios.interceptors.request.use(async (config) => {
            const authToken = await authUser.getIdToken();
            // eslint-disable-next-line no-param-reassign
            config.headers.Authorization = `Bearer ${authToken}`;

            // eslint-disable-next-line no-console
            console.log(config.headers);
            return config;
        }, error => Promise.reject(error));
    }

    return (
        <div className={`layout ${className}`} id={id}>
            <ShoppingCartQuickViewContext.Provider value={{
                cartQuickViewOpen,
                showCartQuickView: () => setCartQuickViewOpen(true),
                hideCartQuickView: () => setCartQuickViewOpen(false),
                toggleCartQuickView: () => setCartQuickViewOpen(!cartQuickViewOpen),
            }}
            >
                {children}
                {SlidingPane && (
                    <SlidingPane
                        closeIcon={(

                            <i className="fas fa-chevron-right has-text-white is-large" />

                        )}
                        className="shopping-cart-sliding-pane-main"
                        overlayClassName="some-custom-overlay-class"
                        isOpen={cartQuickViewOpen}
                        // title="Hey, it is optional pane title.  I can be React component too."
                        // subtitle="Optional subtitle."
                        onRequestClose={() => setCartQuickViewOpen(false)}
                    >
                        <ShoppingCartQuickView />
                    </SlidingPane>
                )}
            </ShoppingCartQuickViewContext.Provider>
        </div>
    );
};

Layout.defaultProps = {
    id: '',
    className: '',
};

Layout.propTypes = {
    id: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
};

export default Layout;
